import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import usePermission from "../../config/permissions";
import { BASE_URL } from "../../config/axios";
import { confirmToast, CustomTooltip, handleErrorToast } from "../CustomFunctions";
import axios from "axios";
import { Calender, ChevronRightIcon, ChevronUPDownIcon, DownArrowIcon, InfoIcon, RefreshIcon, SettingIcon, SuccessIcon, SyncingIcon, DocumentIconResize, WarningIcon, HourGlass, LightBulbIcon, Office, Employee } from "../AllSvg";
import { badgeStyle, cardIconStyle, getBtnStyle, getResultCardStyle, spinnerStyle } from "../../style/CustomFunctionForCss";
import Select from "react-select";
import { CSSForDropdownFilter2, MONTH_OPTIONS } from "../CustomUtilities";


const today = new Date();
const currentMonth = (today.getMonth() + 1).toString();
const currentYear = today.getFullYear().toString();
const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

// format Date → "YYYY-MM-DD"
const toDateString = (d) => d.toISOString().split("T")[0];

/* ─── main component ──────────────────────────────────────────────────────────── */
const AttendanceSyncAndRLM = () => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [subCompany] = useState(sessionStorage.getItem("company_id") || "");
    const [showNote, setShowNote] = useState(true);
    // ── Civilmantra: calendar month till 24 May 2026, 25–24 salary cycle from 25 May 2026 onward ──
    const SALARY_CYCLE_CHANGE_DATE = new Date(2026, 5, 25); // 25 May 2026

    const getCycleMonthYear = (date) => {
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        const isCycleActive = date >= SALARY_CYCLE_CHANGE_DATE;
        if (isCycleActive && date.getDate() >= 25) {
            month += 1;
            if (month > 12) {
                month = 1;
                year += 1;
            }
        }
        return { month: month.toString(), year: year.toString() };
    };

    const getDefaultMonthYear = (companyId) => {
        if (companyId === subCompany) {
            return getCycleMonthYear(today);
        }
        return { month: currentMonth, year: currentYear };
    };
    /* ── Attendance Sync state ────────────────────────────────────────────── */
    const [attDate, setAttDate] = useState(toDateString(today));
    const [attBuffer, setAttBuffer] = useState(false);
    const [attResult, setAttResult] = useState(null);

    /* ── Employee state ───────────────────────────────────────────────────── */
    const [emp_codes, setEmpCodes] = useState([]);
    const [selectedEmpcode, setSelectedEmpcode] = useState("null");
    const [buffer1, setBuffering1] = useState(false);

    /* ── RLM state ────────────────────────────────────────────────────────── */
    // const [rlmMonth, setRlmMonth] = useState(currentMonth);
    // const [rlmYear, setRlmYear] = useState(currentYear);
    const [rlmBuffer, setRlmBuffer] = useState(false);
    const [rlmResult, setRlmResult] = useState(null);
    // const [startMonth, setStartMonth] = useState(currentMonth);
    // const [startYear, setStartYear] = useState(currentYear);
    // const [endMonth, setEndMonth] = useState(currentMonth);
    // const [endYear, setEndYear] = useState(currentYear);
    const initialMonthYear = getDefaultMonthYear(sessionStorage.getItem('company_id'));
    const [startMonth, setStartMonth] = useState(initialMonthYear.month);
    const [startYear, setStartYear] = useState(initialMonthYear.year);
    const [endMonth, setEndMonth] = useState(initialMonthYear.month);
    const [endYear, setEndYear] = useState(initialMonthYear.year);
    const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
    const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

    /* ── Reset RLM month/year to correct default when company changes ─────── */
    useEffect(() => {
        const defaultMonthYear = getDefaultMonthYear(toggleCompany);
        setStartMonth(defaultMonthYear.month);
        setStartYear(defaultMonthYear.year);
        setEndMonth(defaultMonthYear.month);
        setEndYear(defaultMonthYear.year);
    }, [toggleCompany]);

    /* ── Fetch employee list whenever company changes ─────────────────────── */
    useEffect(() => {
        const fetchEmployees = async () => {
            if (!toggleCompany || toggleCompany === "null") {
                setEmpCodes([]);
                setSelectedEmpcode("null");
                return;
            }
            setBuffering1(true);
            try {
                const res = await axios.get(
                    `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
                );

                // if res.data is an array:  setEmpCodes(res.data)
                // if res.data has a key:    setEmpCodes(res.data.results ?? res.data.employees ?? [])
                setEmpCodes(Array.isArray(res.data) ? res.data : (res.data.results || []));
            } catch (err) {
                handleErrorToast(err);
                setEmpCodes([]);
            } finally {
                setBuffering1(false);
            }

            setSelectedEmpcode("null");
        };

        fetchEmployees();
    }, [toggleCompany]);


    /* ── API: Attendance Sync ─────────────────────────────────────────────── */
    // const runAttendanceSync = async () => {
    //     setAttBuffer(true);
    //     setAttResult(null);
    //     try {
    //         let res;
    //         if (selectedEmpcode && selectedEmpcode !== "null") {
    //             // ── Employee-specific sync ──────────────────────────────────
    //             res = await axios.get(
    //                 `${BASE_URL}/wfm/atttoday-emp/${attDate}/${selectedEmpcode}/`
    //             );
    //             const empLabel = options.find(o => o.value === selectedEmpcode)?.label || selectedEmpcode;
    //             toast.success(`Attendance synced for ${empLabel} on ${attDate}!`);
    //         } else {
    //             // ── Sub-company-wide sync (existing logic unchanged) ────────
    //             res = await axios.get(
    //                 `${BASE_URL}/wfm/atttoday-subcompany/${attDate}/${toggleCompany}/`
    //             );
    //             toast.success(`Attendance synced for ${attDate}!`);
    //         }
    //         setAttResult({ ...res.data, syncedFor: selectedEmpcode !== "null" ? "emp" : "company" });
    //     } catch (err) {
    //         handleErrorToast(err);
    //     } finally {
    //         setAttBuffer(false);
    //     }
    // };

    const runAttendanceSync = async () => {
        const isEmpSync = selectedEmpcode && selectedEmpcode !== "null";
        const empLabel = options.find(o => o.value === selectedEmpcode)?.label || selectedEmpcode;

        // ── confirmation message differs by mode ──────────────────────────────
        const confirmMessage = isEmpSync
            ? `Sync attendance only for "${empLabel}" on ${attDate}?`
            : `No employee selected. This will sync attendance for the entire sub-company on ${attDate}. Do you want to continue?`;

        confirmToast(confirmMessage, async () => {
            setAttBuffer(true);
            setAttResult(null);
            try {
                let res;
                if (isEmpSync) {
                    // ── Step 1: fetch employee detail to get machine_code ──────
                    let machineCode;
                    try {
                        const empDetailRes = await axios.get(
                            `${BASE_URL}/wfm/ourcompanydetailsbyemp/${selectedEmpcode}/`
                        );
                        machineCode = empDetailRes?.data?.machine_code;
                    } catch (err) {
                        handleErrorToast(err);
                        setAttBuffer(false);
                        return;
                    }

                    if (!machineCode) {
                        toast.error(`Machine code not found for ${empLabel}. Cannot sync.`);
                        setAttBuffer(false);
                        return;
                    }

                    // ── Step 2: sync using machine_code instead of emp_code ────
                    res = await axios.get(
                        `${BASE_URL}/wfm/atttoday-emp/${attDate}/${machineCode}/`
                    );
                    toast.success(`Attendance synced for ${empLabel} on ${attDate}!`);
                } else {
                    res = await axios.get(
                        `${BASE_URL}/wfm/atttoday-subcompany-timeout/${attDate}/${toggleCompany}/`
                    );
                    toast.success(`Attendance synced for ${attDate}!`);
                }
                setAttResult({
                    ...res.data,
                    syncedFor: isEmpSync ? "emp" : "company",
                });
            } catch (err) {
                console.log(err, "errr");

                const status = err?.response?.status;

                if (status === 524) {
                    toast.error(
                        "The Attendance Sync Service is currently experiencing downtime. Please contact the IT Department for further assistance."
                    );
                } else {
                    handleErrorToast(err);
                }
            } finally {
                setAttBuffer(false);
            }
        });
    };

    // const runAttendanceSync = async () => {
    //     const isEmpSync = selectedEmpcode && selectedEmpcode !== "null";
    //     const empLabel = options.find(o => o.value === selectedEmpcode)?.label || selectedEmpcode;

    //     // ── confirmation message differs by mode ──────────────────────────────
    //     const confirmMessage = isEmpSync
    //         ? `Sync attendance only for "${empLabel}" on ${attDate}?`
    //         : `No employee selected. This will sync attendance for the entire sub-company on ${attDate}. Do you want to continue?`;

    //     confirmToast(confirmMessage, async () => {
    //         setAttBuffer(true);
    //         setAttResult(null);
    //         try {
    //             let res;
    //             if (isEmpSync) {
    //                 res = await axios.get(
    //                     `${BASE_URL}/wfm/atttoday-emp/${attDate}/${selectedEmpcode}/`
    //                 );
    //                 toast.success(`Attendance synced for ${empLabel} on ${attDate}!`);
    //             } else {
    //                 res = await axios.get(

    //                     // `${BASE_URL}/wfm/atttoday-subcompany/${attDate}/${toggleCompany}/`
    //                     `${BASE_URL}/wfm/atttoday-subcompany-timeout/${attDate}/${toggleCompany}/`
    //                 );
    //                 toast.success(`Attendance synced for ${attDate}!`);
    //             }
    //             setAttResult({
    //                 ...res.data,
    //                 syncedFor: isEmpSync ? "emp" : "company",
    //             });
    //         }
    //         //  catch (err) {
    //         //     handleErrorToast(err);
    //         catch (err) {
    //             console.log(err, "errr");

    //             const status = err?.response?.status;

    //             if (status === 524) {
    //                 toast.error(
    //                     "The Attendance Sync Service is currently experiencing downtime. Please contact the IT Department for further assistance."
    //                 );
    //             } else {
    //                 handleErrorToast(err);
    //             }

    //         } finally {
    //             setAttBuffer(false);
    //         }
    //     });
    // };

    /* ── API: RLM by Month ────────────────────────────────────────────────── */
    const runRlmByMonth = async () => {
        setRlmBuffer(true);
        setRlmResult(null);
        try {
            const res = await axios.get(
                // `${BASE_URL}/wfm/rlmbymonth/v3/${startMonth}/${startYear}/`
                `${BASE_URL}/wfm/rlmbymonth/v4/${startMonth}/${startYear}/`
            );
            setRlmResult(res.data);
            toast.success(`RLM applied for ${MONTH_OPTIONS.find(m => m.value === startMonth)?.label} ${startYear}!`);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setRlmBuffer(false);
        }
    };

    const rlmMonthLabel = MONTH_OPTIONS.find(m => m.value === startMonth)?.label;
    const nullOption = { value: 'null', label: 'Select Employee Code' };
    const options = emp_codes
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const handleChange = (selectedOption) => {
        setSelectedEmpcode(selectedOption ? selectedOption.value : "null");
    };

    /* ── Company change handler ───────────────────────────────────────────── */
    const handleCompanyChange = (e) => {
        setToggleCompany(e.target.value);

    };

    /* ────────────────────────────────────────────────────────────────────────
       RENDER
    ──────────────────────────────────────────────────────────────────────── */
    return (
        <>
            <div style={{ margin: "10px" }} className="content-tabs">

                {/* ── Page heading ─────────────────────────────────────────── */}
                <div style={{
                    display: "flex", gap: "10px",
                    marginBottom: "18px", marginTop: "25px"
                }}>
                    <span style={{ marginTop: '-3px' }}><RefreshIcon size={14} color="rgb(21, 101, 192)" /></span>
                    <div>
                        <h4 className="att-syn-rlm-heading mb-0" style={{ fontSize: '17px' }}>
                            Attendance Sync &amp; RLM Execution
                        </h4>
                        <span className="font-12" style={{ color: "#78909c" }}>
                            Sync daily attendance data and apply Roster Leave Management
                        </span>
                    </div>
                </div>

                {/* ══════════════════════════════════════════════════════════
                    COMBINED INFO NOTE
                ══════════════════════════════════════════════════════════ */}
                <div style={{
                    background: "#fff8e1", border: "1px solid #ffe082",
                    borderLeft: "5px solid #ffa000", borderRadius: "6px",
                    padding: "14px 18px", marginBottom: "20px",
                    fontSize: "13px", color: "#5d4037", lineHeight: "1.75",
                }}>
                    {/* collapsible header */}
                    <div
                        style={{
                            display: "flex", alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer", userSelect: "none",
                        }}
                        onClick={() => setShowNote(p => !p)}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span>
                                <InfoIcon />
                            </span>
                            <strong style={{ fontSize: "14px", color: "#e65100" }}>
                                Note — Attendance Sync &amp; RLM Execution Guidelines
                            </strong>
                        </div>
                        <span style={{ fontSize: "16px", color: "#ffa000", fontWeight: 700 }}>
                            {showNote ?
                                <ChevronUPDownIcon direction="up" color="#F57C00" /> : <ChevronUPDownIcon direction="down" color="#F57C00" />}
                        </span>
                    </div>

                    {showNote && (
                        <div style={{ marginTop: "12px" }}>

                            {/* When to run each */}
                            <p style={{ margin: "0 0 10px 0" }}>
                                <strong><Calender /> When to Execute</strong>
                            </p>
                            <ul style={{ margin: "0 0 12px 22px", padding: 0, lineHeight: "1.9" }}>
                                <li>
                                    <strong>Attendance Sync</strong> — Runs automatically in the background to fetch the latest biometric / device punch data.
                                    Use the button to trigger manually for a selected date. Select a specific employee to sync only their records, or  sync the entire sub-company.
                                </li>
                                <li>
                                    <strong>RLM</strong> — Also runs automatically. Execute manually whenever required,
                                    and <strong>always after every Attendance Sync</strong>.
                                </li>
                            </ul>

                            {/* Mandatory sequence */}

                            <p style={{ margin: "0 0 8px 0" }}>
                                <DocumentIconResize size={20} />  <strong> Recommended Execution Order</strong>
                            </p>
                            <div style={{
                                display: "flex", alignItems: "center", gap: "0",
                                flexWrap: "wrap", marginBottom: "12px",
                            }}>
                                {[
                                    { icon: <SyncingIcon />, label: "Sync Attendance", sub: "(select date → execute)" },
                                    { icon: "→", label: null, sub: null, arrow: true },
                                    { icon: <SettingIcon />, label: "Execute RLM", sub: "(select month/year → execute)" },
                                ].map((step, i) =>
                                    step.arrow ? (
                                        <span key={i} style={{
                                            fontSize: "20px", color: "#ffa000",
                                            padding: "0 8px", fontWeight: 700,
                                        }}>→</span>
                                    ) : (
                                        <div key={i} style={{
                                            background: "#fffde7",
                                            border: "1px solid #ffe082",
                                            borderRadius: "6px",
                                            padding: "6px 14px",
                                            textAlign: "center",
                                            minWidth: "160px",
                                        }}>
                                            <div style={{ fontSize: "18px" }}>{step.icon}</div>
                                            <div style={{ fontWeight: 700, fontSize: "12px", color: "#e65100" }}>
                                                {step.label}
                                            </div>
                                            <div style={{ fontSize: "11px", color: "#8d6e63" }}>{step.sub}</div>
                                        </div>
                                    )
                                )}
                            </div>

                            {/* Warning block */}
                            <div style={{
                                background: "#fff3e0", border: "1px solid #ffb74d",
                                borderRadius: "4px", padding: "9px 12px",
                            }}>
                                <strong><WarningIcon /> Important:</strong> After running Attendance Sync,{" "}
                                <strong>executing RLM is mandatory</strong> — skipping it will leave
                                Unpaid Leave entries out of sync with the latest attendance
                                records, which may cause incorrect payroll deductions.
                            </div>
                        </div>
                    )}
                </div>

                {/* ══════════════════════════════════════════════════════════
                    CARD 1 — ATTENDANCE SYNC
                ══════════════════════════════════════════════════════════ */}
                <div className="att-syn-rlm-card">
                    <div className="table-heading-flex" style={{ marginBottom: "14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={cardIconStyle("#e3f2fd", "#1565c0")}><SyncingIcon /></span>
                            <div>
                                <h5 className="att-syn-rlm-heading mb-0">Attendance Sync</h5>
                                <span className="att-syn-rlm-subheading">Pull latest punch data from biometric devices</span>
                            </div>
                        </div>
                        {/* <span style={badgeStyle("#e3f2fd", "#1565c0")}>Daily</span> */}
                    </div>

                    <div style={{ gap: '16px' }} className="navbar-subsection">


                        {/* Date picker */}
                        <div className="field-cont-div">

                            <input
                                className="attendance-input-field width-10vw   date-uppercase"
                                placeholder="Date"
                                type="date"
                                value={attDate}
                                max={toDateString(today)}
                                onChange={e => setAttDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />

                            {SUPER_ADMIN &&
                                <>
                                    <div className="field-cont-div">
                                        <Office />
                                        <select
                                            type="text"
                                            onChange={handleCompanyChange}
                                            value={toggleCompany}
                                            className="attendance-input-field width-10vw date-field"
                                        >
                                            <option value="null">Select Sub Company</option>
                                            {SUB_COMPANIES.map(company => (
                                                <option key={company.id} value={company.id}>
                                                    {company.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <hr className="field-cont-hr" />
                                </>
                            }
                            <div title="Employee Filter (optional — leave blank to sync entire sub-company)" className="field-cont-div">
                                <>
                                    {buffer1 ? (
                                        <div className="spinner-vsmall"></div>
                                    ) : (
                                        <Employee />
                                    )}

                                    {/* Employee Options */}
                                    <Select
                                        className="attendance-input-field width-20vw date-field"
                                        options={[nullOption, ...options]}
                                        value={
                                            options.find(
                                                (option) => option.value === selectedEmpcode
                                            ) || nullOption
                                        }
                                        placeholder="Search By Code Or Name"
                                        onChange={handleChange}
                                        isClearable
                                        isDisabled={buffer1}
                                        styles={CSSForDropdownFilter2}

                                    />
                                </>

                                <hr className="field-cont-hr" />
                            </div>
                        </div>

                        {/* Execute */}
                        <button
                            onClick={runAttendanceSync}
                            disabled={attBuffer}
                            className="upload-svg"
                            style={getBtnStyle({
                                bg: "#1565c0",
                                disabled: attBuffer,
                                alignSelf: "flex-end",
                            })}
                        >
                            {attBuffer
                                ? <><span style={spinnerStyle} /> Syncing…</>
                                : selectedEmpcode !== "null"
                                    ? "Sync Employee"
                                    : "Sync Attendance"
                            }
                        </button>


                    </div>

                    {/* ── Loading state — shown immediately on button click ── */}
                    {attBuffer && (
                        <div style={getResultCardStyle({
                            background: "#e3f2fd",
                            borderColor: "#90caf9",
                            leftBorderColor: "#1565c0",
                            borderRadius: "6px",
                            padding: "14px 16px",
                            marginTop: "16px",
                            textColor: "#1b5e20",
                            fontSize: "13px",
                        })}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                <span className="spinner-loader" />
                                <div>
                                    <strong style={{ fontSize: "13px", color: "#0d47a1" }}>
                                        {selectedEmpcode !== "null"
                                            ? `Syncing attendance for ${options.find(o => o.value === selectedEmpcode)?.label || selectedEmpcode} on ${attDate}…`
                                            : `Syncing attendance data for ${attDate}…`
                                        }
                                    </strong>
                                    <br />
                                    <span style={{ fontSize: "12px", color: "#1565c0" }}>
                                        <HourGlass size={15} color="#f7a831" /> This may take a few minutes. Please do not close or refresh the page.
                                    </span>
                                </div>
                            </div>
                            <div style={{
                                height: "6px", borderRadius: "4px",
                                background: "#bbdefb", overflow: "hidden",
                            }}>
                                <div style={{
                                    height: "100%", width: "40%",
                                    background: "#1565c0", borderRadius: "4px",
                                    animation: "progressSlide 1.4s ease-in-out infinite",
                                }} />
                            </div>
                            <p style={{ margin: "8px 0 0", fontSize: "11px", color: "#5c8fc7" }}>
                                <LightBulbIcon size={15} color="#faf623" /> Tip: After sync completes, remember to execute RLM to update leave balances.
                            </p>
                        </div>
                    )}




                    {/* Att result */}
                    {attResult && !attBuffer && (
                        <div style={getResultCardStyle({
                            background: "#e8f5e9",
                            borderColor: "#a5d6a7",
                            leftBorderColor: "#2e7d32",
                            borderRadius: "6px",
                            padding: "12px 16px",
                            marginTop: "14px",
                            textColor: "#1b5e20",
                            fontSize: "13px",
                        })}>
                            <strong>
                                <SuccessIcon size={25} bgColor="#cdebcf" tickColor="#2e7d32" />
                                {attResult.syncedFor === "emp" ? " Employee Attendance Synced" : " Attendance Synced"}
                            </strong> — {attDate}
                            {attResult.syncedFor === "emp" && (
                                <span style={{
                                    marginLeft: "8px",
                                    background: "#c8e6c9",
                                    color: "#1b5e20",
                                    borderRadius: "4px",
                                    padding: "1px 7px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                }}>
                                    {options.find(o => o.value === selectedEmpcode)?.label || selectedEmpcode}
                                </span>
                            )}
                            <br />
                            <span className="color-card-cobalt-green font-12">
                                Punch data imported successfully. Please execute RLM now to update leave balances.
                            </span>
                        </div>
                    )}
                </div>

                {/* connector arrow */}
                <div className="bill-status-wrapper font-12 dy-bold" style={{
                    justifyContent: "center",
                    margin: "6px 0", color: "#ffa000",
                }}>
                    <span><DownArrowIcon /></span>
                    <span className="text-orange-color">Execute RLM after Attendance Sync</span>
                    <span><DownArrowIcon /></span>
                </div>

                {/* ══════════════════════════════════════════════════════════
                    CARD 2 — RLM BY MONTH
                ══════════════════════════════════════════════════════════ */}
                <div className="att-syn-rlm-card">
                    <div className="table-heading-flex" style={{ marginBottom: "14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={cardIconStyle("#e8f5e9", "#2e7d32")}><SettingIcon /> </span>
                            <div>
                                <h5 className="att-syn-rlm-heading mb-0">Apply RLM by Month</h5>
                                <span className="att-syn-rlm-subheading">Recalculate leave balances &amp; LWP entries for the selected period</span>
                            </div>
                        </div>
                        {/* <div style={{ gap: "6px" }} className="form-flex-wrap">
                            <span style={badgeStyle("#e8f5e9", "#2e7d32")}>Daily</span>
                            <span style={badgeStyle("#fff3e0", "#e65100")}>After Sync</span>
                        </div> */}
                    </div>

                    <div style={{ gap: '16px' }} className="navbar-subsection">

                        {/* Month */}
                        <div className="field-cont-div">
                            {/* <Calender /> */}

                            <input
                                type="month"
                                className="attendance-input-field calender-input width-10vw"
                                value={startDateValue}
                                max={endDateValue}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value) {
                                        const [year, month] = value.split('-');
                                        setStartYear(year);
                                        setStartMonth(month.replace(/^0+/, ''));
                                    }
                                }}
                            />
                            <hr className="field-cont-hr" />
                        </div>


                        {/* Execute */}

                        <button
                            onClick={runRlmByMonth}
                            disabled={rlmBuffer}
                            className="upload-svg"
                            style={getBtnStyle({
                                bg: "#2e7d32",
                                disabled: rlmBuffer,
                                alignSelf: "flex-end",
                            })}
                        >
                            {rlmBuffer ? (
                                <>
                                    <span style={spinnerStyle} />
                                    Applying...
                                </>
                            ) : (

                                'Execute RLM'
                            )}
                        </button>

                    </div>

                    {/* RLM result */}
                    {rlmResult && (
                        <div style={getResultCardStyle({
                            background: "#e8f5e9",
                            borderColor: "#a5d6a7",
                            leftBorderColor: "#2e7d32",
                            borderRadius: "6px",
                            padding: "12px 16px",
                            marginTop: "14px",
                            textColor: "#1b5e20",
                            fontSize: "13px",
                        })}>
                            <strong> <SuccessIcon
                                size={25}
                                bgColor="#cdebcf"
                                tickColor="#2e7d32"
                            />  RLM Applied Successfully</strong> — {rlmMonthLabel} {startYear}
                            <br />
                            <span className="color-card-cobalt-green font-12" >
                                Leave balances and LWP entries recalculated. Verify the payroll
                                summary before processing disbursement.
                            </span>
                        </div>
                    )}
                </div>

            </div>

            <ToastContainer
                position="top-center" autoClose={3000}
                hideProgressBar={false} newestOnTop
                closeOnClick rtl={false}
                pauseOnFocusLoss draggable pauseOnHover
            />
        </>
    );
};



export default AttendanceSyncAndRLM;
